
import { Component, Vue, Prop } from 'vue-property-decorator';
import DemandVsDemandMet from '@/components/DataTab/Charts/ChartComponents/DemandVsDemandMetChart.vue';

@Component({
  components: { DemandVsDemandMet },
})
export default class Plot5 extends Vue {
  @Prop() readonly areaId!: number;
}
